'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselAutoplayButton", {
    enumerable: true,
    get: function() {
        return CarouselAutoplayButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselAutoplayButton = require("./useCarouselAutoplayButton");
const _renderCarouselAutoplayButton = require("./renderCarouselAutoplayButton");
const _useCarouselAutoplayButtonStylesstyles = require("./useCarouselAutoplayButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselAutoplayButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselAutoplayButton.useCarouselAutoplayButton_unstable)(props, ref);
    (0, _useCarouselAutoplayButtonStylesstyles.useCarouselAutoplayButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselAutoplayButtonStyles_unstable')(state);
    return (0, _renderCarouselAutoplayButton.renderCarouselAutoplayButton_unstable)(state);
});
CarouselAutoplayButton.displayName = 'CarouselAutoplayButton';
